// A workgroup is identified by two different guids across the api : the
// structure and the group detail pages use `group-item-<id>`, while the
// "Browse by Groups & Teams" category of the contact filters lists it as
// `workgroups-<id>`. Deep linking to the members of a group therefore has to
// translate the first form into the second one, otherwise the `filters` query
// string matches no checkbox and the list comes back unfiltered.
const GROUP_PREFIX = 'group-item-'
const FILTER_PREFIX = 'workgroups-'

export default group => {
  if (!group) return '/contacts/list'

  const guid = String(group).indexOf(GROUP_PREFIX) === 0
    ? FILTER_PREFIX + String(group).slice(GROUP_PREFIX.length)
    : group

  return `/contacts/list?filters=${guid}`
}
